import InventoriesNew from "components/Inventories/InventoriesNew";
import { Route, Routes } from "react-router-dom";

export default function InventoriesNewPage() {
  return (
    <Routes>
      <Route index element={<InventoriesNew />} />
    </Routes>
  );
}
